import React from 'react'
//import { CSVLink } from "react-csv"
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


export class XLDownload extends React.PureComponent {
    render() {
        const { header, rows, title } = this.props
        const downloadElement = <button type="button" className="btn btn-success pull-right success-button download-button">
            <i className='fa fa-file-excel-o'></i></button>

        let dataRows = []
        if (rows !== undefined && rows.length > 1){ 
            const columns = rows[0]
            dataRows = rows.map((item, index) => { // loop over rows
                let x = {}
                if (index!==0)
                    for (let i = 0; i < columns.length; i++) // loop over single row columns
                        x[columns[i]] = item[i]
                return x
            })
            dataRows.shift()
        }
        const labaleList = header.map((item, index) => 
                <ExcelColumn key={index} label={header[index]} value={rows[0][index]} font= {{sz: "20"}} />)

        return (
            <ExcelFile filename="yahav-query-123" element={downloadElement} >
                <ExcelSheet data={dataRows} name={title}>
                    {labaleList}
                </ExcelSheet>
            </ExcelFile>
        )
    }
}

/*
const dataSet1 = [
    {
        name: "Johson",
        amount: 30000,
        sex: 'M',
        is_married: true
    },
    {
        name: "Monika",
        amount: 355000,
        sex: 'F',
        is_married: false
    },
    {
        name: "John",
        amount: 250000,
        sex: 'M',
        is_married: false
    },
    {
        name: "Josef",
        amount: 450500,
        sex: 'M',
        is_married: true
    }
]

var dataSet2 = [
    {
        name: "Johnson",
        total: 25,
        remainig: 16
    },
    {
        name: "Josef",
        total: 25,
        remainig: 7
    }
]
<ExcelSheet data={dataSet1} name="Employees">
                    <ExcelColumn label="Name" value="name"/>
                    <ExcelColumn label="Wallet Money" value="amount"/>
                    <ExcelColumn label="Gender" value="sex"/>
                    <ExcelColumn label="Marital Status"
                                 value={(col) => col.is_married ? "Married" : "Single"}/>
                </ExcelSheet>
                <ExcelSheet data={dataSet2} name="Leaves">
                    <ExcelColumn label="Name" value="name"/>
                    <ExcelColumn label="Total Leaves" value="total"/>
                    <ExcelColumn label="Remaining Leaves" value="remaining"/>
                </ExcelSheet>


////////////////////////////////csv link
export class CSVDownload extends React.PureComponent {
    render(){
        const { data } = this.props
        return (
            <CSVLink
                data={data}
                onClick={() => {
                    console.log("You click the link"); // 👍🏻 Your click handling logic
                }}
                >
                Download me
            </CSVLink>
        )
    }
}
*/
